<template>
<div
    :id="id"
    class="mdc-tooltip"
    role="tooltip"
    aria-hidden="true">
    <div class="mdc-tooltip__surface mdc-tooltip__surface-animation">
        <slot>{{ label }}</slot>
    </div>
</div>
</template>

<script>
export default {
    props: {
        id: { type: String, required: true },
        label: { type: String, default: "" }
    }
};
</script>

<style lang="scss">
@use "@material/tooltip";
@use "@material/typography/typography";
.mdc-tooltip {
    @include tooltip.fill-color(#fff);
    @include tooltip.label-ink-color(#555555);
    @include tooltip.shape-radius(4px);
    .mdc-tooltip__surface {
        padding: 10px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
        border: 1px solid #e1e1e1;
        line-height: 1.5;
        white-space: pre-line;
        font-size: typography.px-to-rem(13px);
        word-break: keep-all;
    }
}
</style>
